import styled from 'styled-components';

export const TraningContainer = styled.div`
  .training-srch-bar {
    width: 100%;
    height: 70px;
    padding: 10px 25px;
    border-radius: 35px;
    border: none;
    background-color: #f4f4f4;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: -0.13px;
    line-height: 30px;

    &::placeholder {
      opacity: 0.2;
      color: #0a090b;
    }
  }

  .training-srch-btn {
    opacity: 0.5;
    color: #0a090b;
    font-size: 22px;
    letter-spacing: -0.16px;
    line-height: 30px;
    background-color: transparent;
    border: none;
    position: absolute;
    top: 20px;
    right: 30px;
  }
  .training-srch-area {
    position: relative;
    margin: 25px 0 36px;
  }

  .single-filter {
    display: inline-block;
    margin-right: 40px;

    p {
      color: #8c8c8c;

      a {
        color: #0a090b;
      }
    }

    &.right-single-filter {
      text-align: right;
      display: block;
    }
  }

  .training-modules-main {
    background-color: #fafafa;
    padding: 40px 0 75px;
  }

  .training-count {
    font-family: 'Be Vietnam Pro';
    font-size: 20px;
    margin: 0 0 40px 40px;
    color: #5f5f5f;
  }

  .training-new-block {
    background-size: cover;
    background-position: center;
    padding: 50px 0 40px;

    form {
      * {
        font-family: 'Be Vietnam Pro';
      }

      label {
        color: #ffffff !important;
        font-weight: normal;
        font-size: 1em;

        &.hs-error-msg {
          color: ${({ theme: { colors } }) => colors.pink} !important;
        }
      }

      input {
        border-radius: 0;
        padding: 7px !important;
        min-height: 30px !important;
      }

      .actions {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }

  .training-filter-area {
    padding-bottom: 18px;
  }

  .training-new-area {
    max-width: 350px;

    p {
      color: #ffffff;
      font-size: 18px;
      letter-spacing: 0.2px;
      line-height: 28px;
    }

    h3 {
      color: #ffffff;
      font-size: 36px;
      font-weight: bold;
      letter-spacing: -0.27px;
      line-height: 41px;
    }
  }
  .new-training-duration {
    color: #ffffff;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.16px;
    line-height: 28px;
    margin-bottom: 38px;
    display: block;
  }

  @media (max-width: 767px) {
    .partner-banner-bg {
      background-position: 90% 0;
      background-size: cover;
    }
    .inner-hero-area h1 {
      font-size: 36px;
      line-height: 45px;
    }
    .play-banner-video {
      margin-top: 30px;
    }
    .single-filter {
      display: block;
      margin-right: 0;
    }
    .single-filter.right-single-filter {
      text-align: left;
      display: block;
    }
    .single-filter p i {
      position: absolute;
      right: 0;
      top: 5px;
    }
    .single-filter p {
      position: relative;
    }
    .training-new-area .pink-btn {
      display: block;
    }
    .training-count {
      margin: 0 0 40px 15px;
    }
  }
`;

export const TrainingFilter = styled.div`
  background: #fff;
  .filter-title {
    padding: 0 40px 40px 40px;
    color: #0a090b;
    font-family: Vollkorn;
    font-size: 36px;
    font-weight: bold;
    letter-spacing: -0.27px;
    line-height: 42px;
  }
  .form-container {
    padding: 0 40px;
  }
  .flag-container {
    text-align: right;
    margin-top: 20px;
    margin-right: 30px;
  }

  @media screen and (max-width: 450px) {
    height: auto;
    .filter-title {
      padding: 40px 15px;
    }
    .form-container {
      padding: 0 15px;
    }
    .btn-col {
      display: flex;
      justify-content: center;
      margin: auto;
    }
  }
`;
